import React, {createRef, useState} from 'react';
import __ from 'lodash';
import { 
  Icon, 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide, 
  useTheme
} from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ArcDialog = (props) => {
  const contentRef = createRef();
  const theme = useTheme();

  const [record, setRecord] = useState(props.record||{});
  const [state, setState] = useState({open:false, error: false, errorMessage: null});

  if (state.open !== props.open) {
    setState({...state, open: props.open});
    setRecord({...props.record});
  }

  const defaultButtons = {
    ok:{icon: "", label: "Ok", color: "primary"}
    //ok:{icon: "close", label: "Ok", color: "primary"}
  };

  const title = props.title;
  const message = props.message;
  //const buttons = {...defaultButtons, ...props.buttons};
  const buttons = props.buttons? {...props.buttons}:{...defaultButtons};
  const onChange = props.onChange;

  const buttonHandler = (buttonPressed) => {
    onChange({buttonPressed, contentRef});
  }

  const Content = (props) => (
    <div type="content" {...(__.omit(props, ['children']))}>{props.children}</div>
  )

  return (
    <div>
      <Dialog id={`${props.prefix}-dialog-slide`}
        style={{zIndex: 1000}}
        open={props.open}
        maxWidth={props.maxWidth}
        TransitionComponent={Transition}
        keepMounted
        onClose={()=>buttonHandler(props.closeValue===undefined?false:props.closeValue)}
        aria-labelledby={`${props.prefix}-dialog-slide-title`}
        aria-describedby={`${props.prefix}-dialog-slide-description`}
        disableBackdropClick={true}
        {...props.dialogOptions}
      >
        {title
          ?
            <DialogTitle id={`${props.prefix}-dialog-slide-title`}>
              <div style={{clear: "both", backgroundColor: theme.palette.primary.main, padding:"10px"}}>
                {title}
              </div>
            </DialogTitle>
          :
            <></>
        }
        <DialogContent>
          {props.width && <div style={{width: props.width, minWidth: props.width, height: 1}}>&nbsp;</div>}
          <DialogContentText id={`${props.prefix}-dialog-slide-description`}>
            {message}
          </DialogContentText>
          <Content ref={contentRef}>
            {props.children}
          </Content>
          <div style={{height: 10, minHeight:10, maxHeight:10}}/>
        </DialogContent>
        <DialogActions>
          {
            Object.entries(buttons).map(([key, buttonProps]) => {
              const button = __.omit(buttonProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon']);
              const iconOptions = {color:"primary", ...props.iconOptions};
              button['onClick'] = ()=>buttonHandler(key);
              if (typeof buttonProps.hidden === "function") {
                button['hidden'] = buttonProps.hidden({props, error:state.error, errorMessage:state.errorMessage});
              } else {
                button['hidden'] = buttonProps.hidden;
              }
              if (typeof buttonProps.disabled === "function") {
                button['disabled'] = buttonProps.disabled({props, error:state.error, errorMessage:state.errorMessage});
              } else {
                button['disabled'] = buttonProps.disabled;
              }
              iconOptions['hidden'] = button.hidden;
              iconOptions['disabled'] = button.disabled;
              if (iconOptions.disabled) {
                iconOptions['color']=undefined;
              }

              if (buttonProps.icon) {
                button['startIcon'] = (<Icon {...iconOptions}>{buttonProps.icon}</Icon>);
              }

              return (
                <Button {...button}>
                  {buttonProps.label}
                </Button>
              )
            })
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ArcDialog;